import styled, { css } from 'styled-components';
import { th } from 'style/theme';
import { sizes } from 'style';

export const StyledBenefitIcon = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  aspect-ratio: 1/1;
  background-color: ${th('colors.fountainBlue+2')};
  color: ${th('colors.pickledBluewood')};
  transition: background-color 200ms, box-shadow 200ms, font-weight 100ms;
  cursor: pointer;

  @media ${sizes.desktop} {
    border-radius: 16px;
  }

  @media ${sizes.largeDesktop} {
    justify-content: flex-start;
    padding: 12px;
  }

  @media ${sizes.extraLargeDesktop} {
    aspect-ratio: 1.17;
  }

  ${({ $isSelected }) =>
    $isSelected &&
    css`
      background-color: ${th('colors.confetti')};
      box-shadow: ${th('shadows.small')};
      font-weight: 600;
    `};

  > img {
    width: 60%;
    height: 60%;

    @media ${sizes.largeDesktop} {
      width: 45%;
      height: 45%;
    }
  }
`;

export const Name = styled.div`
  display: none;
  max-width: 90%;
  margin-top: 12px;
  font-size: 12px;
  text-align: center;
  white-space: pre-line;

  @media ${sizes.largeDesktop} {
    display: block;
  }
`;
